<template lang="html">
  <div class="sidebar">
    <div id="innopearl_sidebar" v-if="droit_access_platform == 'pearlai'">
      <!-- MENU ACCES UNIQUEMENT A PEARLAI -->
      <div class="menu-items" style="text-align: center">
        <router-link to="/where_to_innovate_finder">
          <img
            :src="require('@/assets/logo_innopearl.png')"
            class="sidebar_logo"
            alt=""
        /></router-link>
      </div>
      <div class="innopearl_sidebar_content">
        <div class="divider_blue_line" />
        <MenuSidebarPearlAI />
      </div>
    </div>

    <div id="innopearl_sidebar" v-else-if="droit_access_platform == 'scouting'">
      <!-- MENU ACCES UNIQUEMENT A SCOUTING PART  -->
      <div class="menu-items" style="text-align: center">
        <router-link to="/rankings">
          <img
            :src="require('@/assets/logo_innopearl.png')"
            class="sidebar_logo"
            alt=""
        /></router-link>
      </div>
      <div class="innopearl_sidebar_content">
        <div class="divider_blue_line" />
        <MenuSidebarScouting />
      </div>
    </div>

    <div
      id="innopearl_sidebar"
      v-else-if="droit_access_platform == 'pearlai_and_scouting'"
    >
      <!-- MENU ACCES UNIQUEMENT A PEARLAI + SCOUTING -->
      <div class="menu-items" style="text-align: center">
        <router-link to="/where_to_innovate_finder">
          <img
            :src="require('@/assets/logo_innopearl.png')"
            class="sidebar_logo"
            alt=""
        /></router-link>
      </div>
      <div class="innopearl_sidebar_content">
        <div class="divider_blue_line" />
        <MenuSidebarPearlAIScouting />
      </div>
    </div>

    <div id="innopearl_sidebar" v-else>
      <!-- MENU APP CLASSIC -->
      <div class="menu-items" style="text-align: center">
        <router-link to="/selectYourChallenge" v-if="role == 'Responsable'">
          <img
            :src="require('@/assets/logo_innopearl.png')"
            class="sidebar_logo"
            alt=""
        /></router-link>
        <router-link to="/selectYourChallenge" v-if="role == 'Customer'">
          <img
            :src="require('@/assets/logo_innopearl.png')"
            class="sidebar_logo"
            alt=""
        /></router-link>
        <router-link to="/expert/my_projects" v-if="role == 'Expert'">
          <img
            :src="require('@/assets/logo_innopearl.png')"
            class="sidebar_logo"
            alt=""
        /></router-link>

        <router-link to="/admin/my_projects" v-if="role == 'Admin'">
          <img
            :src="require('@/assets/logo_innopearl.png')"
            class="sidebar_logo"
            alt=""
        /></router-link>

        <!-- <router-link to="/" > <img :src="require('@/assets/logo_innopearl.png')"  class="sidebar_logo" alt=""></router-link> -->
      </div>
      <div class="innopearl_sidebar_content">
        <div class="divider_blue_line" />
        <MenuSidebar />
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
#innopearl_sidebar {
  /* width: 15%; */
  height: 100%;
  /* top: 0;
   left: 0;
   position: fixed; */
  padding-top: 5px;
  /* background: #CCC; */
  overflow: scroll;
  padding-bottom: 50px;
  z-index: 40;
}
.innopearl_sidebar_content {
  width: 80%;
  margin: auto;
}
.sidebar_logo {
  margin-left: 20px;
  max-width: 120px;
}
.divider_blue_line {
  width: 100%;
  height: 2px;
  background-color: #3783c5;
  margin-top: 20px;
  margin-bottom: 20px;
}
.router-link-active,
.router-link-active * {
  color: blue !important;
}
</style>
<script>
import MenuSidebar from "@/components/sidebar/MenuSidebar.vue";
import MenuSidebarPearlAI from "@/components/sidebar/MenuSidebarPearlAI.vue";
import MenuSidebarScouting from "@/components/sidebar/MenuSidebarScouting.vue";
import MenuSidebarPearlAIScouting from "@/components/sidebar/MenuSidebarPearlAIScouting.vue";
import { mapState } from "vuex";
export default {
  name: "CustomSidebar",
  components: {
    MenuSidebar,
    MenuSidebarPearlAI,
    MenuSidebarScouting,
    MenuSidebarPearlAIScouting,
  },
  data() {
    return {
      expand: false,
    };
  },
  methods: {
  },
  watch: {
    $route(to, from) {
      console.log(to);
      console.log(from);
      console.log(this.expand);
      this.expand = false;
    },
  },
  computed: mapState(["role", "myProjects", "droit_access_platform"]),
};
</script>
